import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: '8px',
    '& .MuiSvgIcon-root': {
      marginRight: '0px',
    },
  },
  dialogPaper: {
    margin: 'auto',
  },
  formLabel: {
    marginBottom: '4px',
  },
  textField: {
    width: '100%',
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      margin: 0,
    },
  },
  dialogActions: {
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '16px 24px',
  },
});
